var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profileType == 'Admin' || _vm.profileType == 'Agency' || _vm.profileType == 'Volunteer')?_c('router-view'):_c('not-found')
}
var staticRenderFns = []

export { render, staticRenderFns }